import { api } from './client';
import type { SessionUser } from '../lib/auth/types';

export async function fetchMe(): Promise<SessionUser> {
  const { data } = await api.get<SessionUser>('/auth/me');
  return data;
}

export async function logout(): Promise<void> {
  await api.post('/auth/logout');
}
